<template>
    <div class="jband-selection">
        <info-panel :selected-project="selectedProject" v-on:infoClosed="onInfoClosed"></info-panel>
        <filter-panel
            :filter-open="filterOpen"
            v-on:filterClosed="onFilterClosed"
            v-on:filtersUpdated="onFiltersUpdated"
            :projects-selected="filteredProjectsByYear"
            v-if="selectedProduct"
        ></filter-panel>
        <div class="selection-panel" :class="{ closed: !mobileOpen }">
            <a href="#" class="selection-toggle-mobile" @click.prevent="mobileOpen = !mobileOpen">
                <span>Project Locator</span>
                <svg viewBox="0 0 172.43 242.72" xmlns="http://www.w3.org/2000/svg">
                    <path d="m70.3 121.36-70.3-70.3 51.06-51.06 121.37 121.36-121.37 121.36-51.06-51.06z"></path>
                </svg>
            </a>
            <div class="selection-header">
                <svg viewBox="0 0 309.2 108.69" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="m74.59 0h18.16v54.34a54.31 54.31 0 0 1 -92.75 38.41l12.84-12.84a36.16 36.16 0 0 0 61.75-25.57zm-36.18 86.89a32.47 32.47 0 0 1 -23-9.54l12.83-12.84a14.38 14.38 0 0 0 24.55-10.17v-54.34h18.21v54.34a32.59 32.59 0 0 1 -32.59 32.55m253.38-30.69c0 9.94-6.77 15.57-17.06 15.57h-9.14v-31.4h9.14c10.29 0 17.06 5.81 17.06 15.65zm-119.08 6.33 6.95-17.41 6.86 17.41zm-35.34 5c0 3.61-2.91 5.63-8.18 5.63h-13.19v-11.33h13c5.72 0 8.36 2.2 8.36 5.54zm-21.37-28.48h11.17c5 0 7.73 1.85 7.73 5.28v.18c0 3.6-3 5.36-8.17 5.36h-10.73zm158.56-13.71h-25.86v32.53l-25.32-32.53h-15.92v45.58l-19.26-45.58h-16.82l-17.27 41c-1.15-6.13-5.53-9.52-11.91-11.62 5.45-2.38 9.5-6.6 9.5-13.72v-.18a13.85 13.85 0 0 0 -4-10c-3.6-3.52-9.05-5.45-16.79-5.45h-31.53v61.52h31.74c6.61 0 12-1.31 15.89-3.7l-1.56 3.7h17.85l4.4-11.08h23.83l4.39 11.08h28.43v-33.77l26.38 33.77h23.47c22.08 0 35-13.19 35-30.95v-.18c0-17.76-12.75-30.42-34.64-30.42m-169.38-20.67h1.14a1.26 1.26 0 0 1 .81.24 1 1 0 0 1 .28.75 1 1 0 0 1 -.28.75 1.17 1.17 0 0 1 -.81.27h-1.14zm0 3.29h1.2l.94 1.75h1.85l-1.34-2.07a1.82 1.82 0 0 0 .85-.79 2.59 2.59 0 0 0 .32-1.25 2 2 0 0 0 -.72-1.6 2.94 2.94 0 0 0 -2-.58h-2.75v6.29h1.61zm-3.49-3.73a5.13 5.13 0 0 1 1.85-1.88 5.19 5.19 0 0 1 5.19 0 5.1 5.1 0 0 1 1.86 1.86 5 5 0 0 1 .67 2.56 5 5 0 0 1 -.68 2.57 5.19 5.19 0 0 1 -1.87 1.88 5 5 0 0 1 -2.61.69 5 5 0 0 1 -2.58-.68 5.05 5.05 0 0 1 -1.84-1.86 5.12 5.12 0 0 1 -.68-2.57 5.06 5.06 0 0 1 .68-2.57m1 8.41a6.45 6.45 0 0 0 3.4.92 6.57 6.57 0 0 0 3.43-.93 6.8 6.8 0 0 0 2.49-2.49 6.66 6.66 0 0 0 .9-3.38 6.67 6.67 0 0 0 -.9-3.39 6.62 6.62 0 0 0 -2.46-2.46 6.78 6.78 0 0 0 -6.82 0 6.78 6.78 0 0 0 -2.44 2.49 6.66 6.66 0 0 0 -.9 3.38 6.77 6.77 0 0 0 3.32 5.84"
                        fill="#fff"
                    />
                </svg>
                <div class="rule"></div>
                <h1>Project Locator</h1>
            </div>
            <div class="selection-description">
                <h2>Since 2002, J-Band has completed hundreds of projects.</h2>
                <p>
                    Use the Projects Filter below to explore the range of projects where J-Band has added to the life of the road. Explore projects by geography, year completed, road type, and more.
                    Click on the dots to see project information, and the stars to see more detailed project&nbsp;stories.
                </p>
                <p>
                    <strong>For any project, click “Request More Info” to request more specifics.</strong>
                </p>
            </div>

            <div class="selection-product">
                <h3>Product</h3>
                <dropdown :options="filteredProductsByTitle" v-on:updateOption="onProductUpdated" v-if="selectedProduct"></dropdown>
            </div>
            <div class="selection-buttons">
                <h3>Project Filter</h3>
                <button class="filter-button" @click.prevent="filterOpen = !filterOpen">
                    <span>Filter Projects</span>
                    <svg viewBox="0 0 172.43 242.72" xmlns="http://www.w3.org/2000/svg">
                        <path d="m70.3 121.36-70.3-70.3 51.06-51.06 121.37 121.36-121.37 121.36-51.06-51.06z"></path>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import InfoPanel from './InfoPanel.vue';
import FilterPanel from './FilterPanel.vue';
import Dropdown from './Dropdown.vue';

export default {
    components: { InfoPanel, FilterPanel, Dropdown },

    props: {
        projectData: {
            type: Object,
            default: null
        },
        selectedProject: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            assetUrl: process.env.VUE_APP_ASSET_URL,
            selectedProduct: null,
            mobileOpen: true,
            filterOpen: false
        };
    },

    computed: {
        filteredProductsByTitle() {
            if (!this.projectData.products.length) return;

            // We only need an array of product titles not all data for our dropdown.
            return this.projectData.products.map(function(products) {
                return products.title;
            });
        },

        filteredProjectsByYear() {
            if (!this.selectedProduct.projects) return;

            // We only need an array of project years not all data for our dropdown.
            return this.selectedProduct.projects.map(function(project) {
                return project.year;
            });
        }
    },

    watch: {
        selectedProject: {
            immediate: true,
            handler(newVal, oldVal) {
                // Make sure we've closed our mobile slide out view and filter view
                if (newVal) {
                    this.mobileOpen = false;
                    this.filterOpen = false;
                }
            }
        },

        filterOpen: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    this.onInfoClosed();
                }
            }
        }
    },

    methods: {
        setInitData() {
            // Just set the current product to 0.
            this.selectedProduct = this.projectData.products[0];
        },

        onProductUpdated(payload) {
            if (this.selectedProduct.title !== payload) {
                this.selectedProduct = this.projectData.products
                    .filter((product) => {
                        return product.title == payload;
                    })
                    .reduce(function(a, b) {
                        return a.concat(b);
                    });
            }
        },

        onFiltersUpdated(selectedFilters) {
            let payload = {
                selectedYear: selectedFilters.selectedYear,
                selectedProduct: this.selectedProduct,
                showPrevious: selectedFilters.showPrevious,
                storiesOnly: selectedFilters.storiesOnly,
                filters: selectedFilters.filters
            };

            if (payload.selectedYear !== null && payload.selectedProduct !== null) {
                console.log('SelectionView.onFiltersUpdated', payload);

                this.onInfoClosed(); // Make sure info panel is closed (no active project)
                this.onFilterClosed(); // Make sure filter panel is closed (no active project)
                this.$emit('selectionUpdated', payload);
            }
        },

        onInfoClosed() {
            this.$emit('selectProject', null);
        },

        onFilterClosed() {
            this.filterOpen = false;
        }
    },

    mounted() {
        this.setInitData();

        window.addEventListener('click', (e) => {
            // close mobile when clicked outside
            if (!this.$el.contains(e.target)) {
                this.mobileOpen = false;
            }
        });
    }
};
</script>

<style scoped lang="scss">
.jband-selection {
    position: absolute;
    display: block;
    box-sizing: border-box !important;
    max-width: 340px * 0.8;
    flex: 0 1 340px * 0.8;
    height: calc(100% - 20px * 0.8);
    padding: 20px * 0.8;

    @media screen and (min-width: 768px) {
        height: 100%;
        position: relative;
        max-width: 340px * 0.9;
        flex: 0 1 340px * 0.9;
        padding: 20px * 0.9;
    }

    @media screen and (min-width: 1024px) {
        max-width: 340px;
        flex: 1 1 340px;
        padding: 20px;
    }

    // Helps to hide the Google logo but will leave for now
    // &:after {

    //     content: '';
    //     position: absolute;
    //     z-index: 1;
    //     top: 0;
    //     left: 0;
    //     bottom: 0;
    //     right: 0;
    //     background: linear-gradient(to left, rgba(#2d2d2d, 0.5), rgba(#2d2d2d, 1));
    // }

    .selection-panel {
        position: relative;
        background-color: #1f1f1f;
        width: 100%;
        height: 100%;
        border-radius: 7px;
        display: flex;
        flex-direction: column;
        // overflow: hidden;
        box-shadow: 0 0 15px rgba(#000, 0.2);
        z-index: 2000; // Make sure this displays above the info panel.
        transition: all 0.45s cubic-bezier(0.645, 0.045, 0.355, 1) 0s; // Cubic.easeInOut

        .selection-toggle-mobile {
            position: absolute;
            top: 15%;
            right: 0;
            background: linear-gradient(darken(#1f1f1f, 8), #1f1f1f 4%, darken(#1f1f1f, 4));
            // background: linear-gradient( #1f1f1f, darken(#1f1f1f, 4));
            box-shadow: 0 0 10px rgba(#000, 0.2);
            border-radius: 0 0 5px 5px;
            padding: 10px 15px;
            margin: 0;
            cursor: pointer;
            display: block;
            text-decoration: none;
            transform-origin: 100% 0;
            transform: rotate(-90deg);
            width: 165px;

            @media screen and (min-width: 768px) {
                display: none;
            }

            span {
                font-size: 14px;
                line-height: 14px;
                letter-spacing: 0.5px;
                font-weight: 500;
                color: #727272;
                text-transform: capitalize;
                padding: 0;
                transition: all 0.35s ease 0s;
            }

            svg {
                position: absolute;
                top: 50%;
                right: 15px;
                width: 10px;
                transform: translateY(-50%) rotate(-90deg);
                height: auto;
                fill: #ff3a1e;
                pointer-events: none;
                transition: all 0.35s ease 0s;
            }
        }

        &.closed {
            @media screen and (max-width: 767px) {
                transform: translateX(-257px);
                // transition: all 0.45s cubic-bezier(0.215,  0.610, 0.355, 1.000) 0s; // Cubic.easeOut
                transition: all 0.45s cubic-bezier(0.645, 0.045, 0.355, 1) 0s; // Cubic.easeInOut

                .selection-toggle-mobile {
                    svg {
                        transform: translateY(-50%) rotate(90deg);
                    }
                }
            }
        }

        .selection-header {
            background: linear-gradient(#ff3a1e, #dc341c);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px * 0.8 15px * 0.8 20px * 0.8 20px * 0.8;
            border-radius: 7px 7px 0 0;
            max-height: 70px; // For IE

            @media screen and (min-width: 768px) {
                padding: 20px * 0.9 15px * 0.9 20px * 0.9 20px * 0.9;
            }

            @media screen and (min-width: 1024px) {
                padding: 20px 15px 20px 20px;
            }

            svg {
                width: 80px * 0.8;
                flex: 0 1 80px * 0.8;
                height: auto;
                margin: 0;
                display: block;
                border: solid 1px transparent; // For IE

                @media screen and (min-width: 768px) {
                    width: 80px * 0.9;
                    flex: 0 1 80px * 0.9;
                }

                @media screen and (min-width: 1024px) {
                    width: 80px;
                    flex: 0 1 80px;
                }
            }

            .rule {
                width: 1px;
                flex: 0 1 1px;
                height: 100%;
                background-color: #fff;
                display: block;
                margin: 0;
            }

            h1 {
                font-weight: 600;
                width: auto;
                flex: 0 1 auto;
                margin: 0;
                padding: 0;
                color: #fff;
                font-size: 18px * 0.8;

                @media screen and (min-width: 768px) {
                    font-size: 18px * 0.9;
                }

                @media screen and (min-width: 1024px) {
                    font-size: 18px;
                }
            }
        }

        .selection-description {
            background-color: #272727;
            padding: 20px * 0.8 15px * 0.8 20px * 0.8 20px * 0.8;
            color: #fff;

            @media screen and (min-width: 768px) {
                padding: 20px * 0.9 15px * 0.9 20px * 0.9 20px * 0.9;
            }

            @media screen and (min-width: 1024px) {
                padding: 20px 15px 20px 20px;
            }

            h2 {
                text-transform: uppercase;
                font-size: 15px * 0.8;
                font-weight: 500;
                margin: 0 0 16px * 0.8 0;
                letter-spacing: -0.25px;
                line-height: 20px * 0.8;

                @media screen and (min-width: 768px) {
                    font-size: 15px * 0.9;
                    margin: 0 0 16px * 0.9 0;
                    line-height: 20px * 0.9;
                }

                @media screen and (min-width: 1024px) {
                    font-size: 15px;
                    margin: 0 0 16px 0;
                    line-height: 20px;
                }
            }

            p {
                font-size: 15px * 0.8;
                line-height: 22px * 0.8;
                font-weight: 300;
                margin: 0 0 20px * 0.8 0;

                @media screen and (min-width: 768px) {
                    font-size: 15px * 0.9;
                    line-height: 22px * 0.9;
                    margin: 0 0 20px * 0.9 0;
                }

                @media screen and (min-width: 1024px) {
                    font-size: 15px;
                    line-height: 22px;
                    margin: 0 0 20px 0;
                }

                &:last-child {
                    margin: 0;
                }
            }
        }

        .selection-product {
            padding: 20px * 0.8;
            border-bottom: solid 1px rgba(#fff, 0.1);

            @media screen and (min-width: 768px) {
                padding: 20px * 0.9;
            }

            @media screen and (min-width: 1024px) {
                padding: 20px;
            }

            h3 {
                text-transform: uppercase;
                color: #727272;
                font-weight: 500;
                letter-spacing: 1px;
                font-size: 12px * 0.8;
                margin: 0 0 10px * 0.8 0;

                @media screen and (min-width: 768px) {
                    font-size: 12px * 0.9;
                    margin: 0 0 10px * 0.9 0;
                }

                @media screen and (min-width: 1024px) {
                    font-size: 12px;
                    margin: 0 0 10px 0;
                }
            }
        }

        .selection-buttons {
            padding: 20px * 0.8;
            border-bottom: solid 1px rgba(#fff, 0.1);

            @media screen and (min-width: 768px) {
                padding: 20px * 0.9;
            }

            @media screen and (min-width: 1024px) {
                padding: 20px;
            }

            h3 {
                text-transform: uppercase;
                color: #727272;
                font-weight: 500;
                letter-spacing: 1px;
                font-size: 12px * 0.8;
                margin: 0 0 10px * 0.8 0;

                @media screen and (min-width: 768px) {
                    font-size: 12px * 0.9;
                    margin: 0 0 10px * 0.9 0;
                }

                @media screen and (min-width: 1024px) {
                    font-size: 12px;
                    margin: 0 0 10px 0;
                }
            }

            .filter-button {
                position: relative;
                width: 100%;
                background: linear-gradient(#ff3a1e, #dc341c);
                border-radius: 5px;
                border: none;
                outline: none;
                text-align: left;

                padding: 15px * 0.8 20px * 0.8;
                margin: 0;
                cursor: pointer;
                display: block;
                text-decoration: none;
                line-height: 16px * 0.9;

                @media screen and (min-width: 768px) {
                    padding: 15px * 0.9 20px * 0.9;
                    line-height: 16px * 0.95;
                }

                @media screen and (min-width: 1024px) {
                    padding: 15px 20px;
                    line-height: 16px;
                }

                span {
                    font-size: 16px * 0.8;
                    font-weight: 600;
                    letter-spacing: 0.5px;
                    color: #fff;
                    text-transform: capitalize;
                    padding: 0;
                    width: calc(100% - 20px * 0.8);
                    transition: all 0.35s ease 0s;
                    display: block;

                    @media screen and (min-width: 768px) {
                        width: calc(100% - 20px * 0.9);
                        font-size: 16px * 0.9;
                    }

                    @media screen and (min-width: 1024px) {
                        width: calc(100% - 20px);
                        font-size: 16px;
                    }
                }

                svg {
                    position: absolute;
                    top: 50%;
                    right: 20px * 0.8;
                    width: 10px;
                    transform: translateY(-50%);
                    height: auto;
                    fill: #fff;
                    pointer-events: none;
                    transition: all 0.35s ease 0s;

                    @media screen and (min-width: 768px) {
                        right: 20px * 0.9;
                    }

                    @media screen and (min-width: 1024px) {
                        right: 20px;
                    }
                }
            }
        }
    }
}
</style>
